const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20banner%20showing%20a%20massive%20spaceship%20fleet%20approaching%20a%20glowing%20blue%20planet%20against%20a%20starry%20black%20space%20background%2C%20dramatic%20lighting%2C%20film%20poster%20quality%2C%20rich%20deep%20colors%2C%20epic%20scale&width=1200&height=600&seq=carousel-banner-01&orientation=landscape',
    title: '科幻巨制专题',
    subtitle: '从星际穿越到流浪地球，探索人类想象力的边界',
    label: '热门专题',
    labelColor: 'bg-primary-500/80 text-background-950',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20wide%20cinematic%20banner%20with%20a%20foggy%20Victorian%20street%20at%20night%2C%20gas%20lamps%20casting%20warm%20golden%20pools%20of%20light%2C%20a%20shadowy%20figure%20in%20a%20long%20coat%2C%20film%20noir%20aesthetic%2C%20atmospheric%20and%20suspenseful&width=1200&height=600&seq=carousel-banner-02&orientation=landscape',
    title: '悬疑惊悚月',
    subtitle: '烧脑反转，让你整夜不敢合眼的精选片单',
    label: '本月主打',
    labelColor: 'bg-accent-500/80 text-background-50',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20banner%20showing%20a%20cozy%20home%20theater%20setup%20with%20a%20large%20screen%20glowing%20in%20a%20dark%20room%2C%20popcorn%20and%20drinks%20on%20a%20coffee%20table%2C%20fairy%20lights%2C%20comfortable%20couch%2C%20inviting%20atmosphere&width=1200&height=600&seq=carousel-banner-03&orientation=landscape',
    title: '周末观影指南',
    subtitle: '编辑精选：这个周末最适合窝在家看的五部电影',
    label: '编辑推荐',
    labelColor: 'bg-primary-500/80 text-background-950',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20wide%20banner%20showing%20a%20beautiful%20animation%20style%20fantasy%20landscape%20with%20floating%20islands%2C%20waterfalls%2C%20and%20colorful%20skies%2C%20Studio%20Ghibli%20inspired%20aesthetic%2C%20hand-drawn%20look%2C%20dreamy%20and%20magical&width=1200&height=600&seq=carousel-banner-04&orientation=landscape',
    title: '动画电影巡礼',
    subtitle: '从宫崎骏到国产新锐，动画世界里的无限可能',
    label: '主题专栏',
    labelColor: 'bg-secondary-500/80 text-background-50',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20classic%20old%20Hollywood%20movie%20set%20with%20vintage%20cameras%2C%20director%20chairs%2C%20and%20film%20lights%20on%20a%20dark%20soundstage%2C%20golden%20age%20of%20cinema%20aesthetic%2C%20nostalgic%20and%20glamorous&width=1200&height=600&seq=carousel-banner-05&orientation=landscape',
    title: '经典回响：百年影史必看之作',
    subtitle: '跨越时代的电影经典，每一部都是影迷必修课',
    label: '经典回顾',
    labelColor: 'bg-accent-500/80 text-background-50',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20cinematic%20wide%20banner%20showing%20an%20intense%20action%20scene%20with%20a%20car%20chase%20through%20a%20neon-lit%20city%20at%20night%2C%20motion%20blur%2C%20rain-slicked%20streets%2C%20vibrant%20reflections%2C%20high-energy%2C%20blockbuster%20style&width=1200&height=600&seq=carousel-banner-06&orientation=landscape',
    title: '动作片大赏：肾上腺素之夜',
    subtitle: '最硬核的动作电影大全免费在线看，燃爆你的深夜',
    label: '专题合集',
    labelColor: 'bg-primary-500/80 text-background-950',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-focus-3-fill text-accent-400 text-xs"></i></span>
            <span className="text-xs text-accent-400 font-medium whitespace-nowrap">深度内容</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">深度策划的电影专题内容，带你从不同视角重新发现电影的魅力</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${item.labelColor}`}>{item.label}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-100 mb-1 group-hover:text-primary-400 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-400 leading-relaxed">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}